import { AdminEnableUserResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../../../../../services/core-api-service";

class EnableUserDialogService {
    public async enableUser(userId: string): Promise<AdminEnableUserResult> {
        return api.admin.enableUser(userId, {})
    }
}

export const service = new EnableUserDialogService()